<template>
  <div class="mc-card">
    <div class="mc-cardhead">
      <b>{{ title }}</b>
      <button
        v-if="editLabel"
        type="button"
        class="mc-linkbtn"
        @click="$emit('edit')"
      >
        {{ editing ? 'Done' : editLabel }}
      </button>
    </div>
    <template v-if="!editing">
      <div
        v-for="[k, v] in rows"
        :key="k"
        class="mc-kv"
        :class="{ 'is-stack': String(v || '').length > 34 }"
      >
        <span class="mc-k">{{ k }}</span>
        <span class="mc-v" :class="{ 'is-empty': !v }">{{
          v || 'Not captured yet'
        }}</span>
      </div>
    </template>
    <div v-else class="mc-card-editor">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReviewGroupCard',
  props: {
    title: { type: String, required: true },
    // [[label, value], ...]
    rows: { type: Array, required: true },
    editLabel: { type: String, default: '' },
    // shows the editor slot in place of the summary rows
    editing: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.mc-card {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 14px;
  padding: 16px;
  margin-bottom: 12px;
  box-shadow: 0 1px 2px rgba(20, 20, 43, 0.04),
    0 4px 14px rgba(20, 20, 43, 0.05);
}

.mc-card-editor {
  border-top: 1px solid #ededf2;
  margin-top: 2px;
  padding-top: 14px;
}

.mc-cardhead {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.mc-cardhead b {
  font-size: 14.5px;
  font-weight: 700;
  color: #14142b;
}

.mc-linkbtn {
  border: 0;
  background: none;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  color: #0052b3;
  cursor: pointer;
  padding: 4px 0;
}

.mc-kv {
  display: flex;
  justify-content: space-between;
  gap: 14px;
  padding: 8px 0;
  border-bottom: 1px dashed #e8e8e8;
  font-size: 13.5px;
}

.mc-kv:last-child {
  border-bottom: 0;
}

.mc-kv.is-stack {
  display: block;
}

.mc-kv.is-stack .mc-k {
  display: block;
  flex: none;
  margin-bottom: 3px;
}

.mc-kv.is-stack .mc-v {
  display: block;
  text-align: left;
  font-weight: 500;
  line-height: 1.5;
}

.mc-k {
  color: #6e7191;
  flex: 0 0 42%;
}

.mc-v {
  color: #333333;
  font-weight: 600;
  text-align: right;
  flex: 1;
  overflow-wrap: anywhere;
}

.mc-v.is-empty {
  color: #6e7191;
  font-weight: 400;
  font-style: italic;
}
</style>
